import { useContext } from "react";
import { Context } from "../../../utils/main-context/MainContext";

import { Link, useParams } from "react-router-dom";

import "./card-info.scss";

import { FaArrowUpRightFromSquare } from "react-icons/fa6";

import projects from "../../../database/projects.json";

const CardInfo = () => {
  const { workInfoActive } = useContext(Context);

  const params = useParams();

  const project = projects.projects.find((data) => data.id === params?.id);

  return (
    <section className={workInfoActive ? "card-info active" : "card-info"}>
      <div className="container">
        <h3 className="title">Informations</h3>
        <h5 className="subtitle">Technologies</h5>
        <ul className="technology-list">
          {project.technologies.map((data, ind) => (
            <li className="technology-item" key={ind}>
              <span>-</span>
              <span>{data}</span>
            </li>
          ))}
        </ul>
        <ul className="url-list">
          <li className="url-item">
            <Link
              to={project.project_url}
              target="_blank"
            >
              <span>Visit site</span>
              <FaArrowUpRightFromSquare />
            </Link>
          </li>
          <li className="url-item">
            <Link
              to={project.project_github_url}
              target="_blank"
            >
              <span>In GitHub</span>
              <FaArrowUpRightFromSquare />
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default CardInfo;
